import React, { Suspense, lazy } from 'react';
import HeroSection from '../components/HeroSection';
import Footer from '../components/Footer';

const BelowFold = lazy(() => import('./BelowFold'));

const Portfolio: React.FC = () => {
  return (
    <>
      <main id="main" tabIndex={-1} className="relative outline-none">
        <HeroSection />
        {/* Holds the footer below the fold while the rest of the page loads. */}
        <Suspense fallback={<div className="min-h-[100svh]" />}>
          <BelowFold />
        </Suspense>
      </main>
      <Footer />
    </>
  );
};

export default Portfolio;
